import { useEffect, type ReactNode } from 'react';
import { Icon } from './Icon';

export interface ToastProps {
  open: boolean;
  children: ReactNode;
  duration?: number;
  onDismiss?: () => void;
  /** When the tab bar is not shown, sit lower. */
  noTabs?: boolean;
}

/** Bottom toast for confirmations only. Never used for errors. */
export function Toast({ open, children, duration = 2600, onDismiss, noTabs }: ToastProps) {
  useEffect(() => {
    if (!open || !onDismiss) return;
    const t = setTimeout(onDismiss, duration);
    return () => clearTimeout(t);
  }, [open, duration, onDismiss]);
  if (!open) return null;
  return (
    <div role="status" className={`fw-toast${noTabs ? ' fw-toast--no-tabs' : ''}`}>
      <Icon name="checkmark-circle" size={20} />
      <span className="fw-toast__text">{children}</span>
    </div>
  );
}
